
class TerminalCtrl  
  @$inject: ["$rootScope", "$scope", "$state", "$stateParams", "Lightbox", "Device"]  
  constructor: ($rootScope, $scope, $state, $stateParams, Lightbox, Device)->
    Device.get({_id: $stateParams._id}).$promise.then (result)=>
      $scope.device = result   
    
    $scope.screenshot = (device)->            
      $scope.device.$screenshot().then (data)->
        $scope.screenshot.data = data

    $scope.preview = (screenshot)->
      opts = 
        url: "data:image/png;base64,#{screenshot}"      
      Lightbox.openModal [opts], 0
    


module.exports = TerminalCtrl




// WEBPACK FOOTER //
// ./src/component/device/terminal/controller.coffee